import {create} from 'zustand';

import {createSelectors} from './zustand';

interface ViewState {
    previewWidth: number;
    previewHeight: number;
    backgroundColor: string;

    setBackgroundColor: (color: string) => void;
    setPreviewWidth: (size: number) => void;
    setPreviewHeight: (size: number) => void;
}

const useViewStoreBase = create<ViewState>()((set, get) => ({
    previewWidth: 0,
    previewHeight: 0,
    backgroundColor: '',

    setBackgroundColor: (color) => set({backgroundColor: color}),
    setPreviewWidth: (size) => set((state) => ({previewWidth: size})),
    setPreviewHeight: (size) => set((state) => ({previewHeight: size})),
}));

export const useViewStore = createSelectors(useViewStoreBase);
